import { uuid } from '../../../utils';
import { FormFiled, FormFieldTypes } from '../../../models';

export const ITEMS: FormFiled[] = [
  {
    id: uuid(),
    type: FormFieldTypes.text,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
  },
  {
    id: uuid(),
    type: FormFieldTypes.multipleSelection,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
    options: [{ title: '', orderNumber: 0 }],
  },
  {
    id: uuid(),
    type: FormFieldTypes.number,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
  },
  {
    id: uuid(),
    type: FormFieldTypes.date,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
  },
  {
    id: uuid(),
    type: FormFieldTypes.separator,
    requiredForInitiation: false,
    orderNumber: 0,
    whoCanView: ['all'],
  },
  {
    id: uuid(),
    type: FormFieldTypes.signature,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
  },
  {
    id: uuid(),
    type: FormFieldTypes.longText,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
  },
  {
    id: uuid(),
    type: FormFieldTypes.singleSelection,
    requiredForInitiation: false,
    whoCanView: [],
    whoCanAnswer: [],
    title: '',
    description: '',
    orderNumber: 0,
    options: [{ title: '', orderNumber: 0 }],
  },
];
